import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-deletion-dialog',
    templateUrl: './deletion-dialog.component.html',
    styleUrls: ['./deletion-dialog.component.scss'],
    imports: [MatButton]
})
export class DeletionDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeletionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

  }

  onYesClick(): void{
    this.dialogRef.close(true);

  }

  onNoClick(): void{
    this.dialogRef.close(false);
  }

}
